import { RouteObject } from "react-router";
import { CustomerHtzAhuListRoute } from "./ahus/customer-htz-ahu-list-route";
import { CustomerHtzAhuRoute } from "./ahus/[airHandlingUnitId]/customer-htz-ahu-route";
import { CustomerHtzSummaryListRoute } from "./summaries/customer-htz-summary-list-route";
import { CustomerHtzAhuDataRoute } from "./ahus/[airHandlingUnitId]/data/[ahuDataId]/customer-htz-ahu-data-route";

export const customerHtzRoutes: RouteObject[] = [
  // no index page defined
  {
    path: "ahus",
    element: <CustomerHtzAhuListRoute />,
  },
  {
    path: "ahus/:airHandlingUnitId",
    element: <CustomerHtzAhuRoute />,
  },
  {
    path: "ahus/:airHandlingUnitId/data/:ahuDataId",
    element: <CustomerHtzAhuDataRoute />,
  },
  {
    path: "summaries",
    element: <CustomerHtzSummaryListRoute />,
  },
];
